import React from 'react';
import './PrivacyPolicy.css'; // Opcionális, ha saját stílust akarsz neki

const PrivacyPolicy = () => {
    return (
        <div className="privacy-container">
            <h1>Adatvédelmi Tájékoztató</h1>
            <p className="privacy-date">Hatályos: 2026. évtől</p>

            <section>
                <h2>1. Bevezetés</h2>
                <p>
                    Ez az Adatvédelmi Tájékoztató tartalmazza a weboldalunk használata során 
                    kezelt személyes adatok kezelésére vonatkozó szabályokat.
                </p>
            </section>

            <section>
                <h2>2. Az adatkezelő adatai</h2>
                <p>Név: Dotnetsoft Bt.</p>
                <p>E-mail cím: <a href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#105;&#110;&#102;&#111;&#64;&#97;&#117;&#116;&#111;&#107;&#101;&#114;&#101;&#115;&#122;&#116;&#101;&#108;&#111;&#46;&#104;&#117;">
  &#105;&#110;&#102;&#111;&#64;&#97;&#117;&#116;&#111;&#107;&#101;&#114;&#101;&#115;&#122;&#116;&#101;&#108;&#111;&#46;&#104;&#117;
</a></p>
            </section>

            <section>
                <h2>3. A kezelt adatok köre</h2>
                <p>
                    Az űrlap kitöltése és a regisztráció során az alábbi adatokat kezeljük:
                </p>
                <ul>
                    <li>Becenév / Név</li>
                    <li>E-mail cím</li>
                    <li>Rendszám, gépjármű adatok (opcionális/szükség esetén)</li>
                </ul>
            </section>

            <section>
                <h2>4. Az adatkezelés célja és jogalapja</h2>
                <p>
                    A megadott adatokat az alábbi célokból kezeljük:
                </p>
                <ul>
                    <li>A szolgáltatás biztosítása, azonosítás és a szolgáltatással kapcsolatos tájékoztatás.</li>
                    <li>E-mail feliratkozás esetén: alkalmi tájékoztatás az oldal új funkcióiról, valamint ellenőrzött autós partnereink ajánlatairól és akcióiról.</li>
                </ul>
                <p>
                    Az e-mail címedre nem küldünk spamet. A hírlevélről és az ajánlatokról bármikor leiratkozhatsz az <a href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#105;&#110;&#102;&#111;&#64;&#97;&#117;&#116;&#111;&#107;&#101;&#114;&#101;&#115;&#122;&#116;&#101;&#108;&#111;&#46;&#104;&#117;">
  &#105;&#110;&#102;&#111;&#64;&#97;&#117;&#116;&#111;&#107;&#101;&#114;&#101;&#115;&#122;&#116;&#101;&#108;&#111;&#46;&#104;&#117;
</a> címen.
                </p>
            </section>

            {/* Vissza gomb vagy link */}
            <div className="privacy-back">
                <a href="/">← Vissza a főoldalra</a>
            </div>
        </div>
    );
};

export default PrivacyPolicy;